(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          const headerOffset = Number(document.documentElement.style.getPropertyValue('--ev-sticky-offset-global').replace('px', '')) || 0;
          const top = card.getBoundingClientRect().top + window.pageYOffset - headerOffset - 16;
          window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
